module.exports = __webpack_public_path__ + "static/media/23.83afbf0d.png";